<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content">
      <myHeader ref="myHeader"></myHeader>

      <!-- 预览母题 -->
      <div class="MobelBox" v-if="previewType" style="overflow-y: auto;">
        <div class="backBox">
          <button class="btn btn-back" @click="closeSub">返回</button>
        </div>

        <p class="add-title">{{previewData.title}}</p>

        <div class="videoList">
          <div class="video-item" v-for="(item,index) in previewData.video" :key="index" @click="lookVideo(item)">
            <p>第{{(index+1)}}小结：{{item.title}}</p>
            <video :src="'https://pic.yuwenjl.com/'+item.video"></video>
          </div>
        </div>
        <div class="write-btnBox">
          <button class="btn btn-close" @click="closeSub">取消</button>
        </div>
      </div>

      <div class="MobelBox" v-else-if="addType">
        <div class="MobelBox-cont">
          <div class="backBox">
            <button class="btn btn-back" @click="closeSub">返回</button>
            <div class="navBtn">
              <div class="nav-item btn-base" :class="mobelType=='base'?'select':''" @click="navSub('base')">基础设置</div>
              <div class="nav-item btn-video" :class="mobelType=='video'?'select':''" @click="navSub('video')">视频设置</div>
            </div>
          </div> 
          <div class="content-item"  v-if="mobelType=='base'">
            <div class="write-txt">
              <p class="write-title">母题名称：<span>*</span></p>
              <div class="write-text">
                <input type="text" v-model="addObj.title">
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">选择步骤:：<span>*</span></p>
              <div class="write-text">
                <el-select v-model="addObj.step" placeholder="请选择">
                  <el-option
                    v-for="item in stepList"
                    :key="item.id"
                    :label="item.title"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="write-txt">
              <p class="write-title">文章内容：<span>*</span></p>
              <div class="write-text">
                <textarea placeholder="" v-model="addObj.content"></textarea>
              </div>
            </div>

            <div class="topicList">
              <div class="topic-item" v-for="(item,index) in addObj.topic" :key="index">
                <div class="topic-title">
                  题目{{(index+1)}}
                  <button class="btn btn-remove" @click="removeTopic(item,index)" v-if="index>0">删除</button>
                </div>
                <div class="write-txt">
                  <p class="write-title"><span>*</span>题干：</p>
                  <div class="write-text">
                    <textarea placeholder="清输入题干" v-model="item.topic"></textarea>
                  </div>
                </div>

                <div class="write-txt">
                  <p class="write-title"><span>*</span>答案：</p>
                  <div class="write-text">
                    <textarea placeholder="请输入答案" v-model="item.answer"></textarea>
                  </div>
                </div>
              </div>
              <button class="btn btn-topic-add" @click="addTopicList">+添加题目</button>
            </div>

            <div class="write-txt">
              <p class="write-title"><span>*</span>母题讲解稿：</p>
              <div class="write-text">
                <textarea placeholder="请输入母题讲解稿" v-model="addObj.explain"></textarea>
              </div>
            </div>
          </div>

          <div class="content-item"  v-else-if="mobelType=='video'"> 
            <div class="topicList">
              <div class="topic-item" v-for="(item,index) in addObj.video" :key="index">
                <div class="topic-title">
                  第{{(index+1)}}小节
                  <button class="btn btn-remove" @click="removeVideo(item,index)">删除</button>
                </div>
                <div class="write-txt">
                  <p class="write-title"><span>*</span>小节名称：</p>
                  <div class="write-text">
                    <input type="text" placeholder="请输入小节名称" v-model="item.title">
                  </div>
                </div>

                <div class="write-txt write-ai">
                  <p class="write-title"><span>*</span>上传课件:</p>
                  <div class="write-text">
                    <div class="img" @mouseenter="imgShow" @mouseleave="imgHide" v-if="item.video">
                      <video :src="'https://pic.yuwenjl.com/'+item.video" alt=""></video>
                      <div class="hover" v-if="imgType">
                        <i class="icon-delete" @click="imgRemove"></i>
                      </div>
                    </div>
                    <el-upload
                      :action="'https://upload.qiniup.com'"
                      :data="uploadObj"
                      list-type="picture-card"
                      :before-upload="(file)=>{return beforeUploadVideo(file,item)}"
                      :on-success="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,'video')}"
                      :on-progress="handleProgressImg"
                      :on-remove="(response, file, fileList)=>{return handleSuccessVideo(response, file, fileList,item,'video')}"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                      <img
                        width="100%"
                        :src="'https://pic.yuwenjl.com/' + item.video"
                        alt=""
                      />
                    </el-dialog>
                  </div>
                </div>
              </div>
              <button class="btn btn-topic-add" @click="addVideo">+添加小节</button>
            </div>
          </div>

          <div class="write-btnBox">
            <button class="btn btn-save" @click="saveSub">保存</button>
            <button class="btn btn-close" @click="closeSub">取消</button>
          </div>
        </div>
      </div>

      <div class="organiza-txt"  v-loading="loading" :element-loading-text="loadTxt" v-else>
        <div class="organiza-title clear">
          <div class="organiza-left" @click="addSub">
            <p>添加母题</p>
          </div>
          <div class="searchBox clear">
            <div class="search-item name">
              <p>母题名称：</p>
              <input type="text" placeholder="请输入要搜索的内容库名称" v-model="obj.title">
            </div>
            <div class="search-btnBox">
              <button class="btn btn-search" @click="searchSub">搜索</button>
              <button class="btn btn-reset" @click="resetSub">重置</button>
            </div>
          </div>
        </div>
        <div class="organiza-list">
          <div class="titleList">
            <p v-for="item in titleList" v-bind:key="item.id">{{item.title}}</p>
          </div>
          <div class="dataList">
            <div class="listItem" v-for="(item,index) in dataList" v-bind:key="(index+1)">
              <p :title="item.key">{{item.key}}</p>
              <p :title="item.title">{{item.title}}</p>
              <p :title="item.add_time">{{item.create_time}}</p>
              <p class="btnList">
                <button title="编辑" class="btn btn-revise" @click="buildSub(item)">编辑</button>
                <button title="删除" class="btn btn-revise" style="color: #ff1919" @click="removeShow(item)">删除</button>
                <button title="预览母题" class="btn btn-remove" style="color: #01CD81;" @click="PreviewShow(item)">预览母题</button>
              </p>
            </div>
          </div>
          
          <div class="block pageBox clear">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="obj.page"
              :page-size="1"
              layout="prev, pager, next, jumper"
              :total="totalPage">
            </el-pagination> 
          </div>
        </div>
      </div>

      <div class="msgBox" v-if="removeType">
        <div class="contv">
          <p class="title">是否确定删除？</p>
          <div class="btnBox">
            <button class="btn btn-close" @click="removeHide">取消</button>
            <button class="btn btn-sub" @click="removeSub">确定</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getMotifList, getMotifDetail,getUploadToken ,aiSetQuestions ,saveMotif ,delMotif ,} from "@/assets/js/api";
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "resource",
  data() {
    return {
      navId:'1',
      childrenID:'1-3',
      titleList:[
        {id:1,title:'序号'},
        {id:2,title:'母题名称'},
        {id:3,title:'添加时间'},
        {id:4,title:'操作'},
      ],
      dataList:[
      ],
      token:'',
      obj:{
        page:1,
        rows:10
      },
      addObj:{
        lid:'',
        title:'',
        step:'',
        content:'',
        explain:'',
        topic:[
          {topic:'',answer:''}
        ],
        video:[
          {title:'',video:'',total_time:'',content:'',type:1}
        ]
      },
      totalPage:0,
      url:'',
      reviewType:false,
      imgType:false,
      uploadObj: {
        token: "",
        key: "",
      },
      dialogVisible:false,
      wordType:false,
      wordList:[],
      questionsObj:{
        name:'',
        sense:'',
      },
      loadTxt:'',
      loading:false,
      addType:'',
      removeType:false,
      removeID:'',
      mobelType:'base',
      stepList: [
        { id: 1, title: "考点定位" },
        { id: 2, title: "标答拆解" },
        { id: 3, title: "步骤逆推" },
        { id: 4, title: "反向解题" },
      ],
      previewType:false,
      previewData:''
    };
  },
  components: {
    navBox,
    myHeader
  },
  mounted(){
    this.token = localStorage.getItem('token');
    this.url = this.$refs.navBox.url;
    this.obj.lid = this.$route.query.lid;
    this.addObj.lid = this.$route.query.lid;
    this.getToken();
    this.getList();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.getList();
    },
    async getToken(){
      var that = this;
      try {
        const response = await getUploadToken(this.obj,this.token);
        if(response.code == 200){
          that.uploadObj.token = response.data.token;   
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    searchSub(){
      this.obj.page = 1;
      this.dataList = [];
      this.getList();
    },

    resetSub(){
      this.obj = {
        page:1,
        rows:10,
      };
      this.addObj = {
        lid:'',
        title:'',
        step:'',
        content:'',
        explain:'',
        topic:[
          {topic:'',answer:''}
        ],
        video:[
          {title:'',video:'',total_time:'',content:'',type:1}
        ]
      };
      this.dataList = [];
        this.addObj.lid = this.$route.query.lid;
      this.getList();
    },

    async getList(){
      var that = this;
      try {
        const response = await getMotifList(this.obj,this.token);
        if(response.code == 200){
          response.data.list.forEach(function(item,index){
            if(item.status==0){
              item.status=false
            } else {
              item.status=true
            }
          })
          that.dataList = response.data.list;
          that.totalPage = response.data.total_page;        
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async buildSub(e){
      var that = this;
      try {
        const response = await getMotifDetail({id:e.id},this.token);
        if(response.code == 200){
          // response.data.practice.forEach(function(item,index){
          //   item.option = 'A.' + item.option_A + '\rB.' + item.option_B + '\rC.' + item.option_C + '\rD.' + item.option_D
          // })
          that.addObj = response.data;
          
          that.addType = 'edit';    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    async saveSub(){
      var that = this;
      console.log(this.addObj)
      if(this.addObj.title == ''){
        that.$message('请填写母题名称');
        throw new Error("EndIterative");
      }
      if(this.addObj.step == ''){
        that.$message('请选择步骤');
        throw new Error("EndIterative");
      }
      if(this.addObj.content == ''){
        that.$message('请填写文章内容');
        throw new Error("EndIterative");
      }
      if(this.addObj.explain == ''){
        that.$message('请填写母题讲解稿');
        throw new Error("EndIterative");
      }
      
      try {
        this.addObj.topic.forEach(function(item,index){
          if(item.topic == ''){
            that.$message('请填写题目'+(index+1)+'题干');
            throw new Error("EndIterative");
          }
          if(item.video == ''){
            that.$message('请填写题目'+(index+1)+'答案');
            throw new Error("EndIterative");
          }
        });
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };

      try {
        this.addObj.video.forEach(function(item,index){
          if(item.title == ''){
            that.$message('请填写第'+(index+1)+'小结的名称');
            throw new Error("EndIterative");
          }
          if(item.video == ''){
            that.$message('请选择第'+(index+1)+'小结的视频');
            throw new Error("EndIterative");
          }
        });
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };

      try {
        const response = await saveMotif(this.addObj,this.token);
        if(response.code == 200){
          that.$message('成功');
          that.closeSub();
          that.getList();    
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    closeSub(){
      this.addType = '';
      this.addObj = {
        lid:'',
        title:'',
        step:'',
        content:'',
        explain:'',
        topic:[
          {topic:'',answer:''}
        ],
        video:[
          {title:'',video:'',total_time:'',content:'',type:1}
        ]
      };
      this.addObj.lid = this.$route.query.lid;
      this.previewType = false;
      this.previewData = '';
    },
    
    examHide(){
      this.wordType = false;
    },

    examRemove(index){
      this.addObj.practice.splice(index,1);
    },

    addTopic(){
      this.addObj.practice.push(
        {option:'',answer:''}
      )
    },

    async reviewShow(e){
      var that = this;
      try {
        const response = await getEnglishDetail({id:e.id},this.token);
        if(response.code == 200){
          response.data.practice.forEach(function(item,index){
            item.option = 'A.' + item.option_A + '\rB.' + item.option_B + '\rC.' + item.option_C + '\rD.' + item.option_D
          })
          that.addObj = response.data;
          that.wordType = true;
          that.addType = '';
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
      
    },

    async aiTopic(e){
      var that = this;
      this.loadTxt = 'AI出题中，请稍后';
      this.loading = true;
      this.questionsObj = {
        name : this.addObj.name,
        sense : this.addObj.sense,
        type:3
      }
      try {
        const response = await aiSetQuestions(this.questionsObj,this.token);
        if(response.code == 200){
            e.answer = response.data.topic.answer;
            e.topic_title = response.data.topic.topic;
            e.option = 'A.' + response.data.topic.option_A + '\rB.' + response.data.topic.option_B + '\rC.' + response.data.topic.option_C + '\rD.' + response.data.topic.option_D
            that.loadTxt = '';
            that.loading = false;
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    topicSub(){
      var that = this;
      try {
        this.addObj.practice.forEach(function(item,index){
          if(item.option == ''){
            that.$message('请填写题目'+(index+1)+'选项');
            throw new Error("EndIterative");
          }
          if(item.answer == ''){
            that.$message('请填写题目'+(index+1)+'答案');
            throw new Error("EndIterative");
          }
        });
      } catch(e) {
          if (e.message != "EndIterative") {
              throw e;
          } else {
              return // 如果跳出forEach循环的同时要终止下面的代码执行  则写这个  如果要继续执行下面的代码  则不需要return
          }
      };
      this.wordType = false;
    },
    
    numCheck(e,i,type){
      var that = this;
      var num = e.sentence;
      num = num.length;
      if(num > i){
          if(type == 'sentence'){
              e.sentence = e.sentence.slice(0,i);
              that.$forceUpdate();
              that.$message('已超出128个字数');
              return false;
          }
      }
    },

    addSub(){
      this.addType = 'add';
    },

    removeShow(e){
      this.removeID = e.id;
      this.removeType = true;
    },

    async removeSub(){
      var that = this;
      try {
        const response = await delMotif({id:this.removeID,lid:this.$route.query.lid},this.token);
        if(response.code == 200){
          that.$message('删除成功');
          that.removeType = false;
          that.removeID = '';
          that.getList();
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    removeHide(){
      var that = this;
      that.removeType = false;
      that.removeID = '';
    },

    removeTopic(e,index){
      this.addObj.topic.splice(index,1);
    },

    addTopicList(){
      this.addObj.topic.push(
        {topic:'',answer:''}
      ) 
    },

    navSub(e){
      this.mobelType = e;
    },

    imgShow(){
      this.imgType = true;
    },

    imgHide(){
      this.imgType = false;
    },

    imgRemove(){
      this.addObj.image = '';
    },

    beforeUploadVideo(file,item) {
      console.log(file,item,'====filefilefile==')
      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      audioElement.addEventListener("loadedmetadata",
          function () {
            console.log(parseInt(audioElement.duration))
            item.total_time = parseInt(audioElement.duration)
      });

      this.loading = true;
      this.uploadObj.key = file.uid + file.name; // key为上传后文件名 必填
    },

    handleSuccessVideo(response, file, fileList,e,type,num) {
      e.video = response.key;
      this.loading = false;
      this.uploadObj.key = "";
    },

    handleRemoveVideo(response, file, fileList,index,type,num) {
      this.addObj.video[index].video = '';
    },

    handleProgressImg(event, file, fileList) {
      this.loadTxt = "已上传" + file.percentage.toFixed(0) + "%";
    },

    addVideo(){
      this.addObj.video.push(
        {title:'',video:'',total_time:'',content:'',type:1}
      )
    },

    PreviewShow(e){
      this.previewType = true;
      this.previewData = e;
    },
    }
  }

  
</script>
<style scoped>
  .dataList .listItem p, 
  .organiza-list p{
    width: calc( 100% / 4 );
  }

  .dataList .listItem p .btn{
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
  }

  .MobelBox{
    padding: 20px;
    box-sizing: border-box;
    width: 100%;
    height: calc( 100% - 120px );
    overflow: hidden;
  }

  .MobelBox .backBox{
    position: relative;
  }

  .navBtn{
    font-size: 0;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%,0);
  }

  .navBtn .nav-item{
    display: inline-block;
    vertical-align: top;
    color: #333333;
    font-size: 24px;
    margin-right: 24px;
    padding-bottom: 4px;
  }

  .navBtn .nav-item.select{
    font-size: 26px;
    font-weight: bold;
    border-bottom: solid 4px #01CD81;
  }

  .MobelBox .write-txt{
    display: block;
    width: 100%;
    margin-bottom: 20px;
  }

  .MobelBox .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
  }

  .MobelBox .write-title span{
    color: #E2231A;
  }

  .MobelBox .write-text{
    display: inline-block;
    vertical-align: top;
    width: 80%;
    margin-left: 20px;
    position: relative;
  }

  .MobelBox .write-text span{
    font-size: 14px;
    color: #E2231A;
    margin-top: 10px;
    display: block;
  }

  .MobelBox .write-text .btn-word-remove{
    color: #fff;
    font-size: 18px;
    background-color: #F26060;
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
    margin-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 36px;
    position: absolute;
    right: 0;
    top: 0;
  }

  .MobelBox .write-text .btn{
    color: #fff;
    font-size: 18px;
    background-color: #F26060;
    border-radius: 6px;
    height: 36px;
    line-height: 36px;
    margin-left: 30px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0px 36px;
    position: absolute;
  }

  .MobelBox input,
  .MobelBox textarea{
    width: 550px;
    height: 330px;
    background-color: transparent;
    border-radius: 6px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
    border: solid 1px rgba(51, 51, 51, 0.3);
  }

  .MobelBox input{
    height: 45px;
    width: 200px;
  }

  .write-btnBox{
    float: right;
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }

  .write-btnBox .btn{
    width: 145px;
    height: 51px;
    line-height: 51px;
    border-radius: 8px;
    color: #fff;
    background-color: #00C7A3;
    padding: 0;
    margin: 0;
    font-size: 20px;
  }

  .write-btnBox .btn.btn-close{
    color: #999999;
    background-color: #F5F5F5;
    margin-left: 80px;
  }

  .msgBox .contv{
    padding: 40px 73px;
    border-radius: 32px;
  }

  .msgBox .title {
    text-align: center;
    margin-bottom: 50px;
  }

  .msgBox .cont .write-title{
    font-size: 18px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
  }

  .msgBox .cont .write-text{
    display: inline-block;
    vertical-align: top;
  }

  .msgBox .cont>>> .el-input--suffix .el-input__inner{
    width: 300px;
  }

  .msgBox .btnBox{
    margin-top: 30px;
  }

.organiza-txt>>>.el-upload{
  width: 100%;
  display: block;
}

.organiza-txt>>>.el-button--small span{
  width: 100%;
  text-align: center;
  display: block;
}

.organiza-txt>>>.el-button--primary{
  background-color: transparent;
  border: none;
  font-size: 15px;
}

.write-txt>>> .el-radio__inner{
  width: 20px;
  height: 20px;
}

.write-txt>>> .el-radio__inner::after{
  width: 10px;
  height: 10px;
}

.reviewBox .write-text input,
.write-txt>>> .el-radio-group{
  display: inline-block;
  vertical-align: middle;
}

.write-txt .title{
  font-size: 20px;
  color: #333333;
  font-weight: bold;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
}

.write-txt .btn-topic-ai,
.write-txt .btn-topic-remove{
  color: #fff;
  font-size: 18px;
  background-color: #F26060;
  border-radius: 6px;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  box-sizing: border-box;
  padding: 0px 36px;
}

.MobelBox .write-text .btn.btn-topic-ai{
  background-color: #00C7A3;
  color: #fff;
}

.write-txt .btn-topic-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  border: solid 1px #00C7A3;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-left: 30px;
  box-sizing: border-box;
  padding: 0px 24px;
}

.reviewBox .write-text input{
  margin-right: 20px;
}

.btn-add{
  font-size: 18px;
  color: #00C7A3;
  border-radius: 6px;
  padding: 6px 24px;
  box-sizing: border-box;
  display: block;
  margin-top: 37px;
  border: solid 1px #00C7A3;
}

.content-item{
  display: block;
  margin-bottom: 70px;
}

.write-setup{
  margin-top: 30px;
}

.write-setup .write-text p{
  color: #777777;
  font-size: 12px;
  display: inline-block;
  line-height: 39px;
  height: 39px;
  vertical-align: top;
  margin-left: 20px;
}

.MobelBox .write-text .btn.btn-setup{
  font-size: 16px;
  color: #fff;
  background-color: #00C7A3;
  border-radius: 6px;
  box-sizing: border-box;
  position: relative;
  height: 39px;
  line-height: 39px;
}

.MobelBox .MobelBox-cont {
  display: block;
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
  padding: 30px;
  border-radius: 6px;
}

.backBox .btn-choose{
  background-color: #00C7A3;
  border-radius: 8px;
  color: #fff;
  font-size: 22px;
  box-sizing: border-box;
  padding: 10px 24px;
  float: right;
}

.word-item{
  border-bottom: 2px dashed #AAAAAA;
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.topicList{
  display: block;
}

.topic-title{
  font-size: 20px;
  color: #333333;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  margin-bottom: 20px;
}

.topic-title .btn-add,
.topic-title .btn-remove{
  font-size: 18px;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  height: 36px;
  line-height: 36px;
  background-color: #6098F2;
  background-image: none;
  width: 110px;
  border-radius: 6px;
}

.topic-title .btn-remove{
  margin-left: 40px;
  background-color: #F26060;
  color: #6098F2;
  color: #fff;
}

.topic-title .btn-add{
  background-color: #F5F5F5;
  color: #999999;
  margin-left: 20px;
}

.btn-topic-add{
  font-size: 18px;
  color: #01CD81;
  margin: 30px 0 20px;
  display: block;  
  border: solid 1px #01CD81;
  border-radius: 6px;
  padding: 3px 30px;
  box-sizing: border-box;
}

.videoList{
  font-size: 0;
}

.videoList .video-item{
  display: block;
  margin-bottom: 20px;
}

.videoList .video-item p{
  font-size: 18px;
  color: #333333;
  display: block;
  margin-bottom: 15px;
}

.videoList .video-item video{
  width: 200px;
  display: block;
  cursor: pointer;
}

.add-title{
  font-size: 20px;
  color: #333;
  margin: -10px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/resource/motif.vue